export class ViewModel {
  constructor(params) {
    this.name = params.name;
    this.role = params.role;
    this.avatar = params.avatar;

    this.hasAvatar = ko.computed(() => {
      const avatarUrl = ko.toJS(this.avatar);
      if (!avatarUrl) return false;
      if (avatarUrl.includes('/img/preview-dummy.png')) return false;
      return true;
    });
    this.showRole = ko.computed(() => Boolean(ko.toJS(this.role)));
  }
}
